import { MaintenanceWindow } from '@app/@shared/models/maintenance-window.model';
import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-maintenance-window',
  templateUrl: './maintenance-window.component.html',
  styleUrls: ['./maintenance-window.component.scss'],
})
export class MaintenanceWindowComponent {
  @Input() window!: MaintenanceWindow;
  codeInput = '';
  error = '';

  constructor(private modalCtrl: ModalController, private afAuth: AngularFireAuth, private router: Router) {}

  async validateCode() {
    if (this.codeInput === this.window.code) {
      this.modalCtrl.dismiss(true);
    } else {
      this.error = 'Folio incorrecto. Por favor, inténtalo nuevamente.';

      // No cerrar sesión ni redirigir, solo mostrar error
      // El usuario puede intentar nuevamente
    }
  }
}
